const contactUsButton = document.querySelector('.contact__us__tag__button');

if (contactUsButton) {
    contactUsButton.addEventListener('click', () => {
        document.querySelector('.contact__us__tag').classList.toggle('active');
    });
}

document.querySelectorAll('.button-copy').forEach(button => {
    button.addEventListener('click', async () => {
      const parent = button.closest('li');
      if (!parent) return;

      const link = parent.querySelector('a');
      if (!link) return;

      const text = link.textContent.trim();

      try {
        await navigator.clipboard.writeText(text);

        button.classList.add('copied');
        setTimeout(() => button.classList.remove('copied'), 1500);
      } catch (err) {
        console.error('Ошибка копирования:', err);
      }
    });
});

const tabButtons = document.querySelectorAll('.contact__tabs__button');
  const tabBlocks = document.querySelectorAll('.contact__tabs__block');

  if (tabButtons.length && tabBlocks.length) {
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        tabButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        const targetId = button.getAttribute('data-target');
        const targetIndex = targetId ? targetId.slice(-1) : '';

        tabBlocks.forEach(block => {
          const blockIndex = block.getAttribute('data-toggle')?.slice(-1);

          if (targetIndex === blockIndex) {
            block.classList.add('show', 'active');
          } else {
            block.classList.remove('show', 'active');
          }
        });
      });
    });
  }